module.exports = __webpack_public_path__ + "img/soft_skill_coaching.def7447b.svg";